module.exports = __webpack_public_path__ + "img/bolle-x-haute-route.a95b4df9.svg";